import Immutable from 'seamless-immutable'
import {
  ORDER_PRICE,
  ORDER_QTY,
  ORDER_STOP_PRICE,
  RESET_ORDER_FORM,
  ORDER_TRADE_STATUS,
  TRADE_TIME_IN_FORCE,
  TRADE_LIMIT_TYPE,
  TRADE_REDUCE_ONLY
} from 'actions'
import {TRADE_TYPES, LIMIT_TYPES, TIME_IN_FORCE} from 'constants'

const reducer = (
  state = Immutable({
    [TRADE_TYPES.LIMIT]: {
      limitType: LIMIT_TYPES.TIF,
      timeInForce: TIME_IN_FORCE.TIF.GTC,
      reduceOnly: false
    },
    [TRADE_TYPES.MARKET]: {},
    [TRADE_TYPES.STOP]: {
      limitType: LIMIT_TYPES.TIF,
      timeInForce: TIME_IN_FORCE.TIF.GTC
    },
    [TRADE_TYPES.TAKE_PROFIT]: {
      limitType: LIMIT_TYPES.TIF,
      timeInForce: TIME_IN_FORCE.TIF.GTC
    }
  }),
  {
    type, formType, buyOrSell, ...payload
  }
) => {
  switch (type) {
  case ORDER_PRICE:
    return state.setIn([formType, buyOrSell, 'price'], payload.price || null)
  case ORDER_QTY:
    return state.setIn([formType, buyOrSell, 'orderQty'], payload.orderQty || null)
  case ORDER_STOP_PRICE:
    return state.setIn([formType, buyOrSell, 'stopPrice'], payload.stopPrice || null)
  case ORDER_TRADE_STATUS:
    return state.setIn([formType, buyOrSell, 'tradeStatus'], payload.tradeStatus)
  case RESET_ORDER_FORM:
    return state.setIn([formType, buyOrSell], {})
  case TRADE_LIMIT_TYPE:
    return state.setIn([formType, 'limitType'], payload.limitType)
  case TRADE_TIME_IN_FORCE:
    return state.setIn([formType, 'timeInForce'], payload.timeInForce)
  case TRADE_REDUCE_ONLY:
    return state.setIn([formType, 'reduceOnly'], payload.reduceOnly)
  default:
    return state
  }
}

export default reducer
